export { default as AdditionalInformation } from './AdditionalInformation';
export { default as Email } from './Email';
export { default as EmrAndEhr } from './EmrAndEhr';
export { default as MediaAndDevices } from './MediaAndDevices';
export { default as System } from './System';
export { default as Network } from './Network';
export { default as NameAndLocation } from './NameAndLocation';
